<template>
  <div class="bg-white-200 rounded-xl p-3 mb-3 flex-y-center">
    <CAvatar :image="avatar" size="md" />
    <div class="flex flex-col items-start pl-2">
      <span class="text-base font-semibold text-dark">{{ name }}</span>
      <span class="text-xs text-gray-450 font-semibold line-clamp-1 mt-px">{{
        email
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import CAvatar from "@/components/CAvatar.vue";

interface User {
  avatar: string;
  name: string;
  email: string;
}
defineProps<User>();
</script>

<style scoped></style>
